export default [
  // Check flag code on https://flagicons.lipis.dev/
  // code should match json file
  {
    code: 'en',
    flag: 'gb',
    name: 'English',
    dashboard: true,
    survey: true,
  },
  {
    code: 'pl',
    flag: 'pl',
    name: 'Polish',
    dashboard: false,
    survey: true,
  },
  {
    code: 'pt',
    flag: 'pt',
    name: 'Portuguese',
    dashboard: false,
    survey: true,
  },
  {
    code: 'es',
    flag: 'es',
    name: 'Spanish',
    dashboard: false,
    survey: true,
  },
  {
    code: 'nl',
    flag: 'nl',
    name: 'Dutch',
    dashboard: false,
    survey: true,
  },
  {
    code: 'zh_CN',
    flag: 'cn',
    name: 'Chinese (Simplified)',
    dashboard: false,
    survey: true,
  },
  {
    code: 'zh_TW',
    flag: 'tw',
    name: 'Chinese (Traditional)',
    dashboard: false,
    survey: true,
  },
  {
    code: 'de',
    flag: 'de',
    name: 'German',
    dashboard: false,
    survey: true,
  },
  {
    code: 'fr',
    flag: 'fr',
    name: 'Français',
    dashboard: true,
    survey: true,
  },
  {
    code: 'ar',
    flag: 'sa',
    name: 'Arabic',
    dashboard: false,
    survey: true,
  },
  {
    code: 'ko',
    flag: 'kr',
    name: '한국어',
    dashboard: true,
    survey: false,
  },
  {
    code: 'ja',
    flag: 'jp',
    name: 'Japanese',
    dashboard: true,
    survey: false,
  },
  {
    code: 'lt',
    flag: 'lt',
    name: 'Lithuanian',
    dashboard: true,
    survey: false,
  },
];
